// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal[id='report-modal'] .modal-content {
  width: 800px;
  max-width: 90vw;
}

.aRfc5MMqkOoc3YhygtPv {
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
  width: 100%;
}

.ZVNhXuBWALjc2tPObate {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
}

.HMUMFy8lAO9BmBwQvQ3t {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative; /* For absolute positioning of error message */
}
.HMUMFy8lAO9BmBwQvQ3t label {
  font-weight: 500;
  color: #f0f0f0;
}
.HMUMFy8lAO9BmBwQvQ3t textarea {
  width: 100%;
  box-sizing: border-box;
  color: #ffffff !important;
}
.HMUMFy8lAO9BmBwQvQ3t textarea:placeholder-shown {
  color: #b6b6b6 !important;
}

.dCb4K8KmpZuVPv_wFKeI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 20px; /* Fixed height to prevent layout shift */
}

.O34QzZ4ZwUuQSiI2bU_R {
  color: #ff4d4f;
  font-size: 0.85rem;
  font-weight: normal;
  position: absolute;
  right: 0;
}

.byR_sixaVsLBGiJvexY6 {
  position: relative;
}
.byR_sixaVsLBGiJvexY6::after {
  content: "*";
  color: #ff4d4f;
  margin-left: 4px;
}

.dXuHmdYO39nlHt5xQ1ou {
  border-color: #ff4d4f !important;
}
.dXuHmdYO39nlHt5xQ1ou:focus {
  border-color: #ff4d4f !important;
}

.pBOtALiVzUjyzfKaxvuc {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.pBOtALiVzUjyzfKaxvuc input {
  flex: 1;
}

.POSwlApqrQcomp4CnbD2 {
  min-width: 200px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.POSwlApqrQcomp4CnbD2 svg {
  width: 24px;
  height: 24px;
  color: #cccccc;
}

.JAZCSzaqxtjidFOsIVMK {
  color: #6439ab !important;
}

.BH9IuoVSmax8a1_OwtxP {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}

.mwAiFPNfqVfGsOHv2Zsg {
  display: flex;
  gap: 12px;
}

._nGQzRBDK9AwEkciOKlA {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.pbLO2psh_xe7kWk2nJLf {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.sq3M5c4PIHMB2kwKwVu_ {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 16px;
  overflow-y: auto;
  max-height: 60vh;
}

.M14C9xHjjKsdrUaKTfqo {
  color: #f0f0f0;
  font-family: "Inter", sans-serif;
  line-height: 1.6;
}
.M14C9xHjjKsdrUaKTfqo h1,
.M14C9xHjjKsdrUaKTfqo h2,
.M14C9xHjjKsdrUaKTfqo h3,
.M14C9xHjjKsdrUaKTfqo h4,
.M14C9xHjjKsdrUaKTfqo h5,
.M14C9xHjjKsdrUaKTfqo h6 {
  margin-top: 1.5em;
  margin-bottom: 0.75em;
  color: #ffffff;
}
.M14C9xHjjKsdrUaKTfqo h1 {
  font-size: 1.8em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 0.3em;
}
.M14C9xHjjKsdrUaKTfqo h2 {
  font-size: 1.5em;
}
.M14C9xHjjKsdrUaKTfqo h3 {
  font-size: 1.3em;
}
.M14C9xHjjKsdrUaKTfqo p {
  margin-bottom: 1em;
}
.M14C9xHjjKsdrUaKTfqo ul,
.M14C9xHjjKsdrUaKTfqo ol {
  margin-bottom: 1em;
  padding-left: 2em;
}
.M14C9xHjjKsdrUaKTfqo li {
  margin-bottom: 0.5em;
}
.M14C9xHjjKsdrUaKTfqo blockquote {
  border-left: 4px solid #6439ab;
  padding-left: 1em;
  margin-left: 0;
  margin-right: 0;
  font-style: italic;
  color: #cccccc;
}
.M14C9xHjjKsdrUaKTfqo code {
  background-color: rgba(0, 0, 0, 0.3);
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-family: monospace;
}
.M14C9xHjjKsdrUaKTfqo pre {
  background-color: rgba(0, 0, 0, 0.3);
  padding: 1em;
  border-radius: 5px;
  overflow-x: auto;
  margin-bottom: 1em;
}
.M14C9xHjjKsdrUaKTfqo img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1.5em auto;
  border: 1px dashed #666;
  padding: 1em;
  background-color: rgba(0, 0, 0, 0.2);
  text-align: center;
  font-style: italic;
  color: #aaa;
}
.M14C9xHjjKsdrUaKTfqo .PZbHYrbb_HcLYVbO7iip {
  display: block;
  margin: 1.5em auto;
  border: 1px dashed #666;
  padding: 1em;
  background-color: rgba(0, 0, 0, 0.2);
  text-align: center;
  font-style: italic;
  color: #aaa;
}
.M14C9xHjjKsdrUaKTfqo table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}
.M14C9xHjjKsdrUaKTfqo th,
.M14C9xHjjKsdrUaKTfqo td {
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0.5em;
  text-align: left;
}
.M14C9xHjjKsdrUaKTfqo th {
  background-color: rgba(255, 255, 255, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/editor/components/modals/ReportModal/ReportModal.module.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA,EAAA,8CAAA;AADF;AAGE;EACE,gBAAA;EACA,cAAA;AADJ;AAKE;EACE,WAAA;EACA,sBAAA;EAGA,yBAAA;AALJ;AAQI;EACE,yBAAA;AANN;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA,EAAA,yCAAA;AATF;;AAaA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAVF;;AAcA;EACE,kBAAA;AAXF;AAaE;EACE,YAAA;EACA,cAAA;EACA,gBAAA;AAXJ;;AAgBA;EACE,gCAAA;AAbF;AAeE;EACE,gCAAA;AAbJ;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAfF;AAiBE;EACE,OAAA;AAfJ;;AAmBA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;AAkBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAhBJ;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,gCAAA;EACA,gBAAA;AAjBF;AAmBE;;;;;;EAME,iBAAA;EACA,qBAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,iDAAA;EACA,qBAAA;AAlBJ;AAqBE;EACE,gBAAA;AAnBJ;AAsBE;EACE,gBAAA;AApBJ;AAuBE;EACE,kBAAA;AArBJ;AAwBE;;EAEE,kBAAA;EACA,iBAAA;AAtBJ;AAyBE;EACE,oBAAA;AAvBJ;AA0BE;EACE,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAxBJ;AA2BE;EACE,oCAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;AAzBJ;AA4BE;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AA1BJ;AA6BE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AA3BJ;AA8BE;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AA5BJ;AA+BE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AA7BJ;AAgCE;;EAEE,0CAAA;EACA,cAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,0CAAA;AA/BJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `aRfc5MMqkOoc3YhygtPv`,
	"formContainer": `ZVNhXuBWALjc2tPObate`,
	"field": `HMUMFy8lAO9BmBwQvQ3t`,
	"labelContainer": `dCb4K8KmpZuVPv_wFKeI`,
	"inlineError": `O34QzZ4ZwUuQSiI2bU_R`,
	"requiredField": `byR_sixaVsLBGiJvexY6`,
	"errorTextArea": `dXuHmdYO39nlHt5xQ1ou`,
	"locationContainer": `pBOtALiVzUjyzfKaxvuc`,
	"geoButton": `POSwlApqrQcomp4CnbD2`,
	"activeGeoIcon": `JAZCSzaqxtjidFOsIVMK`,
	"actions": `BH9IuoVSmax8a1_OwtxP`,
	"rightActions": `mwAiFPNfqVfGsOHv2Zsg`,
	"previewContainer": `_nGQzRBDK9AwEkciOKlA`,
	"previewActions": `pbLO2psh_xe7kWk2nJLf`,
	"markdownPreview": `sq3M5c4PIHMB2kwKwVu_`,
	"markdownContent": `M14C9xHjjKsdrUaKTfqo`,
	"imagePlaceholder": `PZbHYrbb_HcLYVbO7iip`
};
export default ___CSS_LOADER_EXPORT___;
